<ion-item (click)="clickHandler()" lines="none">
  <c-icon [icon]="icon" slot="end" />
  <ion-label class="label-container">
    <p class="label">{{ label }}</p>
    @if (subLabel) {
      <p class="sub-label">{{ subLabel }}</p>
    }
  </ion-label>
  <ng-content></ng-content>
</ion-item>